export default __webpack_public_path__ + "static/belize-9933a7aa2234b77ad905020742aadf3f.jpg";